(function () {
  function buildWhatsAppUrl(link) {
    var phone = (link.dataset.phone || '').replace(/\D/g, '');
    var message = encodeURIComponent(link.dataset.message || '');
    var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return isMobile
      ? 'https://wa.me/' + phone + '?text=' + message
      : 'https://web.whatsapp.com/send?phone=' + phone + '&text=' + message;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-lmu-whatsapp]') : null;
    if (!link) return;

    event.preventDefault();

    if (window.Shopify && window.Shopify.designMode) return;

    window.location.href = buildWhatsAppUrl(link);
  }, true);
})();
